import { useSelector } from "react-redux";
import { Row, Col, Form } from "react-bootstrap";
import { useMemo } from "react";

import { styles } from "../HRFeedbackStyle";

const CandidateStatus = () => {
  const {
    status,
    emailSend,
    date,
    dateUpdatedStatus,
    dateSendEmailForFullForm,
  } = useSelector((state) => state.ApplicationForm);
  const {
    circulationStatus,
    isContactForIv,
    dateUpdatedCirculationStatus,
    dateSendEmailForInterview,
    interviewCancelReason,
  } = useSelector((state) => state.Circulation);

  const sortedStatuses = useMemo(() => {
    const statuses = [];

    if (emailSend == 1) {
      statuses.push({
        date: dateSendEmailForFullForm?.split(",")[0],
        text: "Email Candidate For Full Form is send SUCCESSFULLY",
        className: "text-primary",
      });
    }

    if (isContactForIv == 1) {
      statuses.push({
        date: dateSendEmailForInterview?.split(",")[0],
        text: "Email Candidate For Interview is send SUCCESSFULLY",
        className: "text-primary",
      });
    }

    if (circulationStatus == 400) {
      statuses.push({
        date: dateUpdatedCirculationStatus?.split(",")[0],
        text: "Circulated to supervisor",
        className: "",
      });
    }

    if (circulationStatus == 500) {
      statuses.push({
        date: dateUpdatedCirculationStatus?.split(",")[0],
        text: "Circulation Status - Approve for interview",
        className: "",
      });
    }

    if (circulationStatus == 120) {
      statuses.push({
        date: dateUpdatedCirculationStatus?.split(",")[0],
        text: "Circulation Status - Reject for interview",
        className: "",
      });
    }

    if (circulationStatus == 130) {
      statuses.push({
        date: dateUpdatedCirculationStatus?.split(",")[0],
        text: `Interview Cancel: Reason (${interviewCancelReason})`,
        className: "text-danger",
      });
    }

    if (status == -10) {
      statuses.push({
        date: date?.split(",")[0],
        text: "Email Candidate For Internship Rejection is send SUCCESSFULLY",
        className: "text-danger",
      });
    }

    if (status == 0 || status == 10) {
      statuses.push({
        date: date?.split(",")[0],
        text: "Pending Review",
        className: "",
      });
    }

    if (status == 50) {
      statuses.push({
        date: dateUpdatedStatus?.split(",")[0],
        text: "Candidate is KIV",
        className: "",
      });
    }

    if (status == 100) {
      statuses.push({
        date: dateUpdatedStatus?.split(",")[0],
        text: "Review Only",
        className: "",
      });
    }

    if (status == 200) {
      statuses.push({
        date: dateUpdatedStatus?.split(",")[0],
        text: "Review and Recommend (Proceed to circulation)",
        className: "",
      });
    }

    if (status == 20) {
      statuses.push({
        date: dateUpdatedStatus?.split(",")[0],
        text: "Candidate Accept Internship Offer",
        className: "",
      });
    }

    if (status == -20) {
      statuses.push({
        date: dateUpdatedStatus?.split(",")[0],
        text: "Candidate Turn Down Internship Offer",
        className: "",
      });
    }

    // Sort by date in descending order (newest first)
    return statuses
      .filter((item) => item.date) // Remove items without dates
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [
    status,
    emailSend,
    date,
    dateUpdatedStatus,
    dateSendEmailForFullForm,
    circulationStatus,
    isContactForIv,
    dateUpdatedCirculationStatus,
    dateSendEmailForInterview,
    interviewCancelReason,
  ]);

  return (
    <Row className="py-2">
      <Col>
        <Form.Label style={styles.TitleStyle}>Candidate Status:</Form.Label>
        <ul>
          {sortedStatuses.map((item, index) => (
            <li key={index} className={item.className}>
              {item.date}&nbsp;{item.text}
            </li>
          ))}
        </ul>
      </Col>
    </Row>
  );
};

export default CandidateStatus;